import type { WegicRequestConfig } from '@wegic/request';
import { agentsRequest } from '@/services/request';

const ANONYMOUS_UID_HEADER = 'x-anonymous-uid';

export interface ClientExperimentVariantAssignment {
  variantId?: string | null;
  variantCode?: string | null;
  source?: string | null;
  exposable?: boolean;
}

function buildClientExperimentBaseRequestConfig(
  anonymousUserId?: string | null,
): WegicRequestConfig {
  return {
    ...(anonymousUserId
      ? {
          headers: {
            [ANONYMOUS_UID_HEADER]: anonymousUserId,
          },
        }
      : {}),
    hideCodeErrorMessage: true,
    hideHTTPErrorMessage: true,
  };
}

export function buildClientExperimentRequestConfig(
  anonymousUserId?: string | null,
  params: WegicRequestConfig['params'] = { withExposure: false },
): WegicRequestConfig {
  return {
    ...buildClientExperimentBaseRequestConfig(anonymousUserId),
    params,
  };
}

export function buildClientExperimentExposureRequestConfig(
  anonymousUserId?: string | null,
): WegicRequestConfig {
  return buildClientExperimentBaseRequestConfig(anonymousUserId);
}

export function getClientExperimentVariant<TAssignment = ClientExperimentVariantAssignment>(
  featureKey: string,
  config: WegicRequestConfig = {},
) {
  return agentsRequest.get<TAssignment>(
    `/experiment-variants/v1/client/${encodeURIComponent(featureKey)}`,
    config,
  );
}

export function reportClientExperimentVariantExposure(
  featureKey: string,
  config: WegicRequestConfig = {},
) {
  return agentsRequest.post(
    `/experiment-variants/v1/client/${encodeURIComponent(featureKey)}/exposure`,
    undefined,
    {
      hideCodeErrorMessage: true,
      hideHTTPErrorMessage: true,
      ...config,
    },
  );
}
